import React from 'react';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import Dialog from 'material-ui/Dialog';

class PasswordReset extends React.Component {
  constructor(props) {
    super(props);
    this.initialState =  {
      email: '',
      errorMessage: '',
      emailErrorText: ''
    };
    this.state = {
      ...this.initialState
    };
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.email !== this.state.email) {
      this.setState({email: nextProps.email});
    }
  }
  handleEmailChange = (event, email) => {
    this.setState({emailErrorText: '', email});
  }
  validateEmailwithRegex = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  validateEmail = () => {
    const {t} = this.props;
    if(this.state.email) {
      if (!this.validateEmailwithRegex(this.state.email)) {
        this.setState({emailErrorText:t('invalid')});
        return false;
      } else {
        return true;
      }
    } else {
      this.setState({emailErrorText:t('required')});
      return false;
    }
  }
  handleResetPassword = () => {
    const {t} = this.props;
    const validatedEmail = this.validateEmail();
    if (validatedEmail) {
      this.props.firebase.auth().sendPasswordResetEmail(this.state.email).then(() => {
        this.props.snackbarOpen();
        this.handleClose();
      }, () => {
        this.setState({errorMessage: t('noUserForEmail')});
      });

    }
  }
  handleClose = () => {
    this.setState(this.initialState);
    this.props.handleClose();
  }
  render() {
    const {t} = this.props;

    const actions = [
      <FlatButton
        label={t('cancel')}
        onTouchTap={this.handleClose}
      />,
      <RaisedButton
        label={t('resetPassword')}
        type="submit"
        primary={true}
        onTouchTap={this.handleResetPassword}
      />,
    ];

    return (
      <Dialog
          title={t('forgotPassword')}
          open={this.props.open}
          onRequestClose={this.handleClose}
          actions={actions}
        >
          <TextField hintText={t('email')}
            floatingLabelText={t('email')}
            errorText={this.state.emailErrorText}
            onChange={this.handleEmailChange}
            onBlur={this.validateEmail}
            defaultValue={this.props.email}
          />
          <br />
          <div style={{color: '#F44336'}}>
            {this.state.errorMessage}
          </div>
      </Dialog>
    );
  }
}

export default translate()(firebase(PasswordReset));



// WEBPACK FOOTER //
// ./src/Auth/PasswordReset.js